import * as DOMPurify from "dompurify";

export const sanitizeHtml = (htmlString, options) => {
  const cleanHtml = DOMPurify.sanitize(htmlString, options);

  return cleanHtml;
};
